// locales/ms.ts — Kamus Bahasa Melayu untuk checkout form MY.
// Dipakai hanya bila form.addressCountry === 'MY'. Form ID tidak tersentuh.
export const MS = {
  fullName: 'Nama Penuh',
  fullNamePlaceholder: 'Nama Penuh',
  nameTooShort: 'Nama terlalu pendek',
  nameMin: (min: number) => `Nama minima ${min} aksara`,
  nameMax: (max: number) => `Nama maksima ${max} aksara`,
  chars: 'aksara',
  whatsapp: 'Nombor WhatsApp',
  whatsappPlaceholder: 'Cth: 0123456789',
  whatsappInvalid: 'Nombor WhatsApp tidak sah',
  digits: 'digit',
  emailInvalid: 'Format emel tidak sah',
  submitOrder: 'Hantar Pesanan',
  orderSummary: 'Maklumat Pesanan',
  shippingMethod: 'Kaedah Penghantaran',
  paymentMethod: 'Kaedah Pembayaran',
  freeShipping: 'Penghantaran Percuma',
  codLabel: 'Bayaran Tunai Semasa Terima (COD)',
  subtotal: 'Subjumlah',
  shipping: 'Penghantaran',
  discount: 'Diskaun',
  totalPay: 'Jumlah Bayaran',
  qty: 'Kuantiti',
  variantHint: 'Pilih salah satu pilihan di bawah',
  customerInfo: 'Maklumat Pelanggan:',
  notIncluded: 'Tidak termasuk',
  trustPayment: 'Pembayaran',
  trustPaymentSub: 'Selamat',
  trustProduct: 'Barangan',
  trustProductSub: 'Original',
  trustShipping: 'Penghantaran',
  trustShippingSub: 'Pantas',
  thanksFallback: 'Pesanan anda telah kami terima dan akan diproses segera.',
  orderId: 'ID Pesanan',
  product: 'Produk',
  payment: 'Pembayaran',
  notChosen: 'Belum dipilih',
  shippingAddressTitle: 'Maklumat Penghantaran',
  name: 'Nama',
  address: 'Alamat',
  estimateTitle: 'Anggaran penghantaran: 2-4 hari bekerja',
  estimateSub: 'Pasukan kami akan memproses dan menghubungi anda via WhatsApp dalam 1×24 jam untuk pengesahan pesanan.',
  waConfirm: 'Sahkan via WhatsApp',
  waConfirmMust: 'Sahkan pesanan',
  waConfirmSub: 'Klik butang di atas untuk mengesahkan pesanan anda',
  waUnavailable: 'Nombor WhatsApp pengesahan belum tersedia',
  waNumberMissing: 'Nombor WhatsApp tidak tersedia. Sila hubungi CS.',
  thanksFooter: 'Terima kasih kerana membeli-belah dengan kami!',
  thanksTitle: 'Pesanan Berjaya!',
  thanksMsgCs: 'Pesanan anda telah kami terima. CS kami akan segera menghubungi via WhatsApp.',
  thanksMsgDefault: 'Terima kasih atas pesanan anda!',
  copied: 'Disalin!',
  verifyTitle: 'Sahkan Alamat & Proses — AI',
  verifySub: 'Semak alamat, WA, penghantaran, kemudian pilih proses atau Tanya CS.',
  share: 'Kongsi',
  shareAlert: 'Pautan halaman ini sudah disalin. Kongsi sebagai bukti pesanan anda.',
  orderTitle: 'Pesanan',
  shipCost: 'Kos Penghantaran',
  shipSubsidy: 'Subsidi Penghantaran',
  shipPaid: 'Penghantaran Dibayar',
  codCost: 'Kos COD',
  uniqueCode: 'Kod unik',
  transferTotal: 'Jumlah yang dipindah',
  totalShort: 'Jumlah Keseluruhan',
  shippingCity: 'Bandar',
  shippingState: 'Negeri',
  shippingPostcode: 'Poskod',
  waMissingShort: 'Nombor WhatsApp belum tersedia',
} as const;

// Pilih teks ikut negara form: MY → Melayu, selain itu → teks Indonesia asal.
export function ms(form: any, pick: (m: typeof MS) => string, fallback: string): string {
  try {
    if ((form as any)?.addressCountry === 'MY') return pick(MS);
  } catch { /* abaikan */ }
  return fallback;
}
